export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
  }).format(amount)
}

// formatDate y formatDateLong: reexportados desde la fuente única en lib/utils.
// Ruta RELATIVA a propósito: este módulo se bundlea en Netlify functions (esbuild),
// que NO resuelve el alias '@/' para value imports (solo vite/tsconfig lo conocen).
export { formatDate, formatDateLong } from '../lib/utils'

export function formatCuit(cuit: string | null | undefined): string {
  if (!cuit) return 'No especificado'
  const clean = cuit.toString().replace(/\D/g, '')
  if (clean.length !== 11) return cuit
  return `${clean.slice(0, 2)}-${clean.slice(2, 10)}-${clean.slice(10)}`
}

/**
 * Build a wa.me URL from a phone number, normalizing to international format (Argentina).
 * Returns null if the phone is empty or invalid after cleaning.
 */
export function buildWhatsAppUrl(telefono: string | null | undefined, mensaje?: string): string | null {
  if (!telefono) return null

  let numero = telefono.replace(/[\s\-().]/g, '')

  // Local Argentine number starting with 0 → strip leading 0 and prepend 54
  if (numero.startsWith('0')) {
    numero = '54' + numero.slice(1)
  }

  // No country code → prepend Argentina (54)
  if (!numero.startsWith('+') && !numero.startsWith('54')) {
    numero = '54' + numero
  }

  numero = numero.replace('+', '')

  if (numero.length < 10) return null

  const url = `https://wa.me/${numero}`
  return mensaje ? `${url}?text=${encodeURIComponent(mensaje)}` : url
}
